module.exports = global["surveylab_datetime_timepicker"] = require("-!/app/node_modules/ts-loader/index.js??ref--4!./timepicker.ts");